export var ImageStatus;
(function (ImageStatus) {
    ImageStatus[ImageStatus["LOADING"] = 1] = "LOADING";
    ImageStatus[ImageStatus["FAILED"] = 2] = "FAILED";
    ImageStatus[ImageStatus["SUCCESS"] = 3] = "SUCCESS";
})(ImageStatus || (ImageStatus = {}));
export var ImageLoadRejectResult;
(function (ImageLoadRejectResult) {
    ImageLoadRejectResult[ImageLoadRejectResult["ERROR"] = 1] = "ERROR";
    ImageLoadRejectResult[ImageLoadRejectResult["CANCEL"] = 2] = "CANCEL";
})(ImageLoadRejectResult || (ImageLoadRejectResult = {}));
